import {faQuestionCircle} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {OverlayTrigger} from '@freckle/educator-materials/ts/components/overlay-trigger'
import {Popover} from '@freckle/educator-materials/ts/components/popover'
import {Text} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import {icon} from './index.module.scss'

type Props = {
  id: string
}

export function TeacherSignupPopover(props: Props) {
  const {t} = useSafeTranslation()

  const popover = (
    <Popover id={props.id}>
      <Text style="subtitle-2">{t('MANAGE_TEACHERS_TEACHER_SIGNUP_POPOVER_SUBTITLE')} </Text>
      <p>{t('MANAGE_TEACHERS_TEACHER_SIGNUP_POPOVER_BODY')}</p>
      <Link href={Routes.rostering.removeSelfRosteredTeachers()} reactRouter>
        {t('MANAGE_TEACHERS_TEACHER_SIGNUP_POPOVER_LINK_TEXT')}
      </Link>
    </Popover>
  )

  return (
    <OverlayTrigger trigger={['click']} placement="top" overlay={popover}>
      <FontAwesomeIcon icon={faQuestionCircle} className={`hidden-print ${icon}`} />
    </OverlayTrigger>
  )
}
